/**
 * 仅改前端展示：autumn → Fall。
 * 不改写提交/匹配用的后端 value（仍为 autumn）。
 */
export function formatSeasonDisplayLabel(raw: string): string {
  const text = raw.trim()
  if (!text) return ''
  if (text.toLowerCase() === 'autumn') return 'Fall'
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}

export function formatSeasonDisplayLabels(raw: string[] | undefined | null): string[] {
  if (!raw?.length) return []
  return raw.map((s) => formatSeasonDisplayLabel(String(s))).filter(Boolean)
}
